import React, { useState } from "react";
import { useHistory } from "react-router";
import "./Login.css";

async function loginUser(credentials) {
  console.log("Started");
  return fetch("https://project-x-01.herokuapp.com/auth/token", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(credentials),
  }).then((data) => data.json());
}

function Login({ setToken, setUser }) {
  const [username, setUsername] = useState();
  const [password, setPassword] = useState();
  const [loading, setIsLoading] = useState(false);

  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const token = await loginUser({
      username,
      password,
    });
    setIsLoading(false);
    console.log(token);
    if (token["error"]) {
      console.log(token["error"]);
    } else {
      console.log(token["access_token"]);
      setToken(token["access_token"]);
      setUser(username);
      history.replace('/');
    }
  };

  return (
    <div>
      <form className="login-wrapper" onSubmit={handleSubmit}>
        <label>
          <p>Username</p>
          <input type="text" onChange={(e) => setUsername(e.target.value)} />
        </label>
        <label>
          <p>Password</p>
          <input
            type="password"
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        <div>
          <button type="submit" className="button is-success mr-2">
            Submit
          </button>
        </div>
      </form>
      {loading && <p>Loading</p>}
    </div>
  );
}

export default Login;
